/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_TitleInputs */

const es_admin_users_title = /** @type {(inputs: Admin_Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuarios`)
};

const en_admin_users_title = /** @type {(inputs: Admin_Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users`)
};

/**
* | output |
* | --- |
* | "Users" |
*
* @param {Admin_Users_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_title = /** @type {((inputs?: Admin_Users_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_title(inputs)
	return en_admin_users_title(inputs)
});
export { admin_users_title as "admin.users.title" }